import { render } from "./CursosWidget.vue?vue&type=template&id=3a249907&scoped=true"
import script from "./CursosWidget.vue?vue&type=script&lang=js"
export * from "./CursosWidget.vue?vue&type=script&lang=js"

import "./CursosWidget.vue?vue&type=style&index=0&id=3a249907&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a249907"]])

export default __exports__